module.exports = __webpack_public_path__ + "img/slot.013bac6d.jpeg";